// TD Draft 2026-09-28 P14 — 'Auf einen Blick' facts accordion item (snippets/td-p14-facts-accordion.liquid).
// The rows follow the selected variant: Bezug / Füllung / Waschen / Lieferumfang per Bezugsart (pre-rendered in
// Liquid), Größe + Gewicht from the variant options, set covers from the cover options, Versand copied from the
// td_delivery_time block of the same page. Delegated document listeners, so it keeps working when Prestige
// re-renders parts of the product info; the accordion itself is not re-rendered (open state stays).
(function () {
  if (window.tdP14FactsBound) return;
  window.tdP14FactsBound = true;

  // TD Draft 2026-09-28 P14 — helpers
  const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const phDe = (text) => '<span class="td-p14-ph">[Platzhalter: ' + esc(text) + ']</span>';
  // TD 2026-10-01 INTL-PDP — translated storefronts (snippets/td-p14-facts-intl.liquid): cfg.t = the locale's words;
  // no placeholders there (a fact without a value hides its row). German: no cfg.t → the German words, output as before.
  const tr = (cfg, key, de) => (cfg && cfg.t && typeof cfg.t[key] === 'string' ? cfg.t[key] : de);
  // '6, 8, 10 oder 12 kg' (unit only once when every value ends in ' kg'), same as the Liquid first paint
  const listDe = (arr, or) => {
    if (arr.length <= 1) return arr.join('');
    const allKg = arr.every((w) => / kg$/.test(w));
    const head = arr.slice(0, -1).map((w) => (allKg ? w.replace(/ kg$/, '') : w));
    return head.join(', ') + ' ' + (or || 'oder') + ' ' + arr[arr.length - 1].replace(/ kg$/, '\u00a0kg');
  };
  // TD Draft 2026-09-28 P14 — also the spelling without 'cm' ('110 x 170' on five kids cotton products)
  const kidsHeight = {
    '90x120cm': '91–120 cm', '90x120': '91–120 cm',
    '100x150cm': '121–150 cm', '100x150': '121–150 cm',
    '110x170cm': '151–170 cm', '110x170': '151–170 cm'
  };

  const readCfg = (root) => {
    if (root.__tdP14Cfg) return root.__tdP14Cfg;
    try {
      const node = root.querySelector('script[data-td-p14-data]');
      root.__tdP14Cfg = node ? JSON.parse(node.textContent) : null;
    } catch (e) {
      root.__tdP14Cfg = null;
    }
    return root.__tdP14Cfg;
  };

  const formFor = (cfg) => document.querySelector('form[id^="product-form-main-' + cfg.pid + '-"]');

  // variant rows in the data: [id, option1, option2, option3, available(0/1)]
  const rowById = (cfg, id) => (cfg.v || []).find((r) => String(r[0]) === String(id)) || null;
  const opt = (row, pos) => (pos > 0 && row ? row[pos] : null);

  const setHtml = (root, key, html) => {
    const el = root.querySelector('[data-td-p14-v="' + key + '"]');
    if (el && el.innerHTML !== html) el.innerHTML = html;
    // TD 2026-10-01 INTL-PDP — translated storefronts: an empty fact hides its row
    if (el && root.hasAttribute('data-td-p14-intl')) {
      const row = el.closest('.td-p14-facts__row');
      if (row) row.hidden = !html;
    }
  };

  // { text, strong }: whole line of the delivery block for this variant + its bold part (the time span)
  // TD Draft 2026-09-28 G5 — number ranges with an en dash ('20-24' → '20–24'), same spelling as the P03 note
  const dashRange = (s) => s.replace(/(\d)\s*-\s*(\d)/g, '$1–$2');
  const shippingText = (variantId) => {
    const items = document.querySelectorAll('[data-td-delivery-time] .td-delivery-time__item[data-variant-id="' + String(variantId).replace(/"/g, '') + '"]');
    for (const item of items) {
      if (item.closest('[data-td-p14-root]')) continue;
      const text = dashRange((item.textContent || '').replace(/\s+/g, ' ').trim());
      const strong = dashRange(((item.querySelector('b, strong') || {}).textContent || '').replace(/\s+/g, ' ').trim());
      if (text) return { text, strong };
    }
    return { text: '', strong: '' };
  };

  const update = (root, row) => {
    const cfg = readCfg(root);
    if (!cfg || !row) return;
    const pos = cfg.pos || {};
    const ph = (text) => (cfg.t ? '' : phDe(text)); // TD 2026-10-01 INTL-PDP — no placeholders abroad
    const type = pos.type > 0 ? opt(row, pos.type) : '*';
    const t = (cfg.types && (cfg.types[type] || cfg.types['*'])) || null;

    // Bezug — set pages: the two chosen covers
    // TD Draft 2026-09-30 MAT — each cover with its fabric from cfg.covMat (pre-rendered in Liquid, Felix 30.09.2026);
    // a value missing from the map gets the placeholder, same as the Liquid first paint; '&nbsp;·' keeps the dot on the cover's line
    if (pos.c1 > 0) {
      const covMat = cfg.covMat || {};
      const fabric = (val) => (Object.prototype.hasOwnProperty.call(covMat, val) ? covMat[val] : ph('Materialzusammensetzung'));
      const c1 = opt(row, pos.c1);
      let html = '1. Bezug: ' + esc(c1) + '&nbsp;· ' + fabric(c1);
      if (pos.c2 > 0) {
        const c2 = opt(row, pos.c2);
        html += '<br>2. Bezug: ' + esc(c2) + '&nbsp;· ' + fabric(c2);
      }
      setHtml(root, 'bezug', html);
      // TD Draft 2026-09-30 P14W — set: warmth level per chosen cover (cfg.covWarm, same numbers as the Liquid first paint)
      const covWarm = cfg.covWarm || {};
      const lvl = (val) => (covWarm[val] ? 'Stufe ' + esc(covWarm[val]) + ' von 5' : ph('Wärmestufe'));
      let warm = '1. Bezug: ' + lvl(c1);
      if (pos.c2 > 0) warm += '<br>2. Bezug: ' + lvl(opt(row, pos.c2));
      setHtml(root, 'warm', warm);
    } else if (t) {
      setHtml(root, 'bezug', t.b);
    }

    if (t) {
      setHtml(root, 'fill', t.f);
      setHtml(root, 'care', t.c);
      setHtml(root, 'scope', t.s);
      // TD Draft 2026-09-28 P14 — Wärme per Bezugsart ('Medizinisch (ohne Bezug)' → note, TD Draft 2026-09-30 P14W)
      if (typeof t.w === 'string' && !(pos.c1 > 0)) setHtml(root, 'warm', t.w);
    }

    // Größe (+ body height for the kids sizes, FAQ table of the template)
    const size = pos.size > 0 ? opt(row, pos.size) : cfg.fixedSize || '';
    if (size) {
      const height = kidsHeight[String(size).toLowerCase().replace(/\s+/g, '')];
      setHtml(root, 'size', esc(size) + (height ? '<br><span class="td-p14-sub">' + esc(tr(cfg, 'height', 'für Körpergröße %H%').replace('%H%', height)) + '</span>' : ''));
    } else {
      setHtml(root, 'size', ph('Größe'));
    }

    // Gewicht (+ weights offered in this Bezugsart and size)
    const weight = pos.weight > 0 ? opt(row, pos.weight) : '';
    if (weight) {
      const hasCover = t ? t.cov !== false : true;
      let offered;
      if (cfg.trunc) {
        // TD Draft 2026-09-28 P14 — more than 250 variants: cfg.v is incomplete, so only the server list is used, and
        // only while Bezugsart and Größe are the ones it was built for (set: both fixed → list always valid)
        const key = cfg.wKey || [];
        const same = (!(pos.type > 0) || type === key[0]) && (!(pos.size > 0) || size === key[1]);
        offered = same ? (cfg.wAvail || []) : [];
      } else {
        const found = new Set();
        (cfg.v || []).forEach((r) => {
          if (!r[4]) return;
          if (pos.type > 0 && r[pos.type] !== type) return;
          if (pos.size > 0 && r[pos.size] !== size) return;
          found.add(r[pos.weight]);
        });
        offered = (cfg.w || []).filter((w) => found.has(w));
      }
      // TD Draft 2026-09-28 P14 — ascending kg, same as the Liquid first paint (whole kg only; anything else keeps its place at the end)
      const kgInt = (w) => (/^\d+ kg$/.test(w) ? parseInt(w, 10) : Infinity);
      offered = offered.map((w, i) => [w, i]).sort((a, b) => (kgInt(a[0]) - kgInt(b[0])) || (a[1] - b[1])).map((x) => x[0]);
      let html = esc(weight) + (hasCover ? ' ' + esc(tr(cfg, 'incl', '(inkl. Bezug)')) : '');
      if (offered.length > 1) {
        html += '<br><span class="td-p14-sub">' + esc(size ? tr(cfg, 'availSize', 'Erhältlich in dieser Größe:') : tr(cfg, 'avail', 'Erhältlich:')) + ' ' + esc(listDe(offered, tr(cfg, 'or', 'oder'))) + '</span>';
      }
      setHtml(root, 'weight', html);
    } else {
      setHtml(root, 'weight', ph('Gewicht'));
    }

    // Versand — same text as the delivery-time block for this variant (rendered for every variant, read by id)
    const ship = root.querySelector('[data-td-p14-ship]');
    if (ship) {
      const { text, strong } = shippingText(row[0]);
      ship.textContent = '';
      if (strong && text.endsWith(strong)) {
        // keep '20–24 Werktage' on one line
        const time = document.createElement('span');
        time.className = 'td-p14-nowrap';
        time.textContent = strong;
        ship.append(text.slice(0, text.length - strong.length), time);
      } else {
        ship.textContent = text;
      }
      ship.hidden = !text;
    }
  };

  const rowFromVariant = (cfg, variant) => {
    if (!variant || !variant.id) return null;
    return rowById(cfg, variant.id) || [variant.id, variant.option1, variant.option2, variant.option3, variant.available ? 1 : 0];
  };

  const refreshRoot = (root, variant) => {
    const cfg = readCfg(root);
    if (!cfg) return;
    let row = variant ? rowFromVariant(cfg, variant) : null;
    if (!row) {
      const id = formFor(cfg)?.querySelector('input[name="id"]')?.value;
      row = id ? rowById(cfg, id) : null;
    }
    update(root, row);
  };

  const refreshAll = (variant, formId) => {
    document.querySelectorAll('[data-td-p14-root]').forEach((root) => {
      const cfg = readCfg(root);
      if (!cfg) return;
      if (formId && formId.indexOf('product-form-main-' + cfg.pid + '-') !== 0) return;
      refreshRoot(root, variant);
    });
  };

  document.addEventListener('variant:change', (event) => {
    // Prestige dispatches on the form; event.target.id is the form id (detail.formId may be the id input)
    const formId = event.target && event.target.getAttribute ? event.target.getAttribute('id') : null;
    refreshAll(event.detail && event.detail.variant, formId);
  });

  const init = () => refreshAll(null, null);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
